import React from 'react';
import { connect } from 'react-redux';
import Header from '../../components/header/Header.component';
import Footer from '../../components/footer/Footer.component';

const layoutStyle = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
};

const mainStyle = {
  flex: '1 0 auto',
  padding: '20px',
};

const Layout = ({ children }) => (
  <div className="app-layout" style={layoutStyle}>
    <Header />
    <div className="nhsuk-width-container-fluid" style={mainStyle}>
      <main className="nhsuk-main-wrapper" id="maincontent" role="main">
        <div className="nhsuk-grid-row">
          <div className="nhsuk-grid-column-full">{children}</div>
        </div>
      </main>
    </div>
    <Footer />
  </div>
);

const mapStateToProps = (state) => ({
  app: state.app,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
